import { StyleFunctionProps } from '@chakra-ui/react';
import Input from './input';

const baseStyle = {
  mx: 0,
};

const sizes = {
  xl: {
    w: '82px',
    h: '82px',
    fontSize: '2xl',
    borderRadius: 'lg',
  },
  lg: {
    h: '72px',
    w: '72px',
    fontSize: '2xl',
    borderRadius: 'lg',
  },
  md: {
    h: '64px',
    w: '64px',
    fontSize: 'xl',
    borderRadius: 'lg',
  },
  def: {
    h: '56px',
    w: '56px',
    fontSize: 'lg',
    borderRadius: 'lg',
  },
  sm: {
    h: '48px',
    w: '48px',
    fontSize: 'md',
    borderRadius: 'lg',
  },
  xs: {
    h: '36px',
    w: '36px',
    fontSize: 'xs',
    borderRadius: 'lg',
  },
  '2xs': {
    h: '24px',
    w: '24px',
    fontSize: '2xs',
    borderRadius: 'lg',
  },
};

const variants = {
  outline: (props: StyleFunctionProps) => Input.variants.outline(props).field,
};

const { defaultProps } = Input;

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
